import React, { useEffect } from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import ReactHtmlParser from 'react-html-parser'
import ContentBlock from 'components/atoms/ContentBlock'
import Typography from 'components/atoms/Typography'
import get from 'lodash.get'
import isEqual from 'lodash.isequal'
import { useDispatch, useSelector } from 'react-redux'
import * as faqActions from '../../../store/modules/faq/actions'
import { HashLink } from 'react-router-hash-link'
import { renderIndexItemClass } from 'helpers/tools'
import './FaqWidget.scss'

function FaqWidget({ data }) {
  const dispatch = useDispatch()
  const firstItemRender = get(data, 'first')
  const lastItemRender = get(data, 'last')
  const title = get(data, 'title')
  const id = get(data, 'id')
  const description = get(data, 'description.value')
  const categoriesIDs = get(data, 'category').map(({ entity }) => entity?.tid)
  const themeClasses = get(data, 'theme.entity.classes')

  const { faqCategory, faqError, loadingFaqCategory } = useSelector(({ faq }) => faq, isEqual)
  const items = get(faqCategory, 'faqQuery.entities')

  useEffect(() => {
    if (!faqCategory) {
      dispatch(faqActions.getFaqCategory({ method: 'faqs', category: categoriesIDs.toString() }))
    }
  }, [])

  return (
    <Container
      id={id}
      fluid="fluid"
      className={`faq-widget ${themeClasses || 'bg-white'} ${renderIndexItemClass(firstItemRender, lastItemRender)}`}
    >
      <Container>
        <Row>
          <Col>
            <ContentBlock>
              <Typography variant="h3" cssClass="title-semibold-lg title">
                {title}
              </Typography>

              {description && <div className="description text-gray-100">{ReactHtmlParser(description)}</div>}
            </ContentBlock>
          </Col>
        </Row>

        <Row>
          <Col>
            <ul className="link-list">
              {!loadingFaqCategory &&
                !faqError &&
                items &&
                Array.isArray(items) &&
                items.map((item, index) => (
                  <li className="link-list-item" key={data.uuid + index}>
                    <HashLink to={item.link.path}>{item.title}</HashLink>
                  </li>
                ))}
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  )
}

export default FaqWidget
